import {
  FETCH_UPDATE_PASSWORD_BEGIN,
  FETCH_UPDATE_PASSWORD_SUCCESS,
  FETCH_UPDATE_PASSWORD_CANCELED,
  FETCH_UPDATE_PASSWORD_FAILURE,
  FETCH_UPDATE_PASSWORD_REAUTHENTICATION_REQUIRED,
  PASSWORD_CLEAR_ERROR,
} from '../actions/password';

export const initialState = {
  error: [],
  instruction: 'Choose a unique password to protect your wallet.',
  isFetching: false,
  reauthenticationRequired: false,
};

const password = (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case FETCH_UPDATE_PASSWORD_BEGIN:
      return {
        ...state,
        error: [],
        isFetching: true,
        reauthenticationRequired: false,
      };
    case FETCH_UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        error: [],
        instruction: 'Password updated successfully',
        isFetching: false,
      };
    case FETCH_UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.payload,
        instruction: '',
        isFetching: false,
      };
    case FETCH_UPDATE_PASSWORD_CANCELED:
      return {
        ...state,
        isFetching: false,
      };
    case FETCH_UPDATE_PASSWORD_REAUTHENTICATION_REQUIRED:
      return {
        ...state,
        error: [],
        instruction: '',
        isFetching: false,
        reauthenticationRequired: true,
      };
    case PASSWORD_CLEAR_ERROR:
      return {
        ...state,
        error: [],
        reauthenticationRequired: false,
        instruction: 'Choose a unique password to protect your wallet.',
      };
    default:
      return state;
  }
};

export default password;
